import { Component, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { areEqual, deepCopy, DwButtonCommand, DwButtonConfig, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwModalConfig, DwModalHandler, DwModalResult, DwRadioItem, DwSecurityUserService } from '@devwareapps/devware-cap';
import { combineLatest, Observable, of } from 'rxjs';
import { AirportWithAddressInfoQueryEntity, CheckRideApplicantTypeAllItems, CheckRideRequestEntity, CheckRideRequestSubStatusAllItems, CheckRideTypeEntity, FlightSchoolApplicantEntity, PilotExaminerEntity, PilotExaminerStatusAllItems, PilotExaminerTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { SchoolSwapStudentRequest } from '../../models/school-swap-student-request.model';
import { SchoolRepositoryService } from '../../services/school-repository.service';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { SchoolChangeApplicantUtilService } from '../../services/school-change-applicant-util.service';
import { SchoolChangeApplicantSwapType, SchoolSwapStudentResult } from '../../models/school-swap-student-result.model';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { AppPermissions } from '../../../../meta-data/app-permissions.enum';

@Component({
  selector: 'app-school-swap-student-modal',
  templateUrl: './school-swap-student-modal.component.html',
  styleUrls: ['./school-swap-student-modal.component.scss']
})
export class SchoolSwapStudentModalComponent implements DwModalHandler, OnInit {

  @ViewChild('mdForm') formApi: DwMetaDataFormApi;
  currentCheckride: CheckRideRequestEntity;
  originalCheckride: CheckRideRequestEntity;
  showCancelSwapOptions: boolean = false;
  cancelSwapText: string = 'The current checkride for the selected applicant will be cancelled.';
  airportInfoList: AirportWithAddressInfoQueryEntity[];
  currentAirportInfo: AirportWithAddressInfoQueryEntity;
  refCheckride: CheckRideRequestEntity;
  examinerDetails: PilotExaminerEntity[];
  lastIsValid: boolean;
  validationStarted: boolean;
  revalidateAfter: boolean;
  allowSwap: boolean;
  lastCheckrideTypeId: number;
  allCheckrideTypes: CheckRideTypeEntity[];
  lastTestTypeId: number;

  constructor(private schoolRepositoryService: SchoolRepositoryService, private examinerRepositoryService: ExaminerRepositoryService, private dateTimeUtilService: DateTimeUtilService, private schoolChangeApplicantUtilService: SchoolChangeApplicantUtilService,
    private dwSecurityUserService: DwSecurityUserService
  ) { }

  modalConfig: DwModalConfig<SchoolSwapStudentRequest>;
  closeModal: EventEmitter<DwModalResult<SchoolSwapStudentResult>>;

  allowOverride: boolean = false;
  overrideErrors: boolean = false;

  isValidForOverride: boolean = false;
  saving: boolean = false;
  savingMessage: string;

  newCheckride: CheckRideRequestEntity;

  newApplicantId: number;

  newApplicant: FlightSchoolApplicantEntity;
  sameApplicantSelected: boolean = false;
  cancelSwapValue: SchoolChangeApplicantSwapType = SchoolChangeApplicantSwapType.cancel;
  cancelSwapOptions: DwRadioItem[] = [
    {
      display: 'Cancel existing checkride',
      value: SchoolChangeApplicantSwapType.cancel
    },
    {
      display: 'Swap Applicant',
      value: SchoolChangeApplicantSwapType.swap
    }
  ]

  ngOnInit(): void {
    // Let's reload the checkride to ensure we have the latest data
    this.schoolRepositoryService.getCheckrideRequest(this.modalConfig.data.checkride.CheckRideRequestId)
      .subscribe(checkride => {
        // Initialize the new checkride data from the request
        this.originalCheckride = checkride;
        this.newCheckride = deepCopy(checkride);

        this.newCheckride.CheckRideRequestId = null;
        this.newCheckride.FlightSchoolApplicantId = null;
        this.newCheckride.CheckRideApplicantTypeId = CheckRideApplicantTypeAllItems.FlightSchoolStudent;

        this.refCheckride = deepCopy(this.newCheckride);

        this.loadAirportInfo();
      });

    this.allowOverride = this.dwSecurityUserService.hasPermission(AppPermissions.checkrideSwapCanOverride, false);

    this.loadReferenceData();
  }

  private loadReferenceData() {
    // this.schoolRepositoryService.getCheckrideTypes()
    //   .subscribe(checkrideTypes => {
    //     this.allCheckrideTypes = checkrideTypes;
    //   });
  }

  verifyingChange = false;

  dataChanged(data?: CheckRideRequestEntity): void {
    if (!this.newCheckride || !data) {
      return;
    }
    const fullCheckride = { ...this.newCheckride, ...data };

    if (!areEqual(fullCheckride, this.newCheckride)) {

      this.newCheckride = fullCheckride;

      this.handleDataChange();
    }
  }

  handleCancelSwapChange() {
    if (this.newApplicant && this.examinerDetails?.length > 0) {
      this.validateApplicantChange()
        .subscribe(result => {

        });
    }
  }

  handleDataChange() {
    if (this.newApplicantId != this.newCheckride.FlightSchoolApplicantId) {
      this.newApplicantId = this.newCheckride.FlightSchoolApplicantId;

      this.schoolRepositoryService.getFlightSchoolApplicant(this.newApplicantId, true)
        .subscribe(applicant => {
          this.setupNewApplicant(applicant);

          return;
        });

      return;
    }

    if ((this.lastCheckrideTypeId != this.newCheckride.CheckRideTypeId || this.lastTestTypeId != this.newCheckride.CheckRideTestTypeId) && this.newApplicantId) {
      this.lastCheckrideTypeId = this.newCheckride.CheckRideTypeId;
      this.lastTestTypeId = this.newCheckride.CheckRideTestTypeId;

      this.handleCheckrideTypeChange();
    }

    this.handleAirportChange();
  }


  airportIdList: number[] = [];

  loadAirportInfo(): void {
    let loadAirports = false;
    if (this.originalCheckride.ScheduledAirportId && this.airportIdList.indexOf(this.originalCheckride.ScheduledAirportId) < 0) {
      this.airportIdList.push(this.originalCheckride.ScheduledAirportId);
      loadAirports = true;
    }

    if (this.currentCheckride?.ScheduledAirportId && this.airportIdList.indexOf(this.currentCheckride.ScheduledAirportId) < 0) {
      this.airportIdList.push(this.currentCheckride.ScheduledAirportId);
      loadAirports = true;
    }

    if (!loadAirports) {
      this.currentAirportInfo = this.getScheduledAirportInfo(this.currentCheckride?.ScheduledAirportId);
      return;
    }

    this.examinerRepositoryService.getAirportInfoList(this.airportIdList)
      .subscribe(airportInfoList => {
        this.airportInfoList = airportInfoList;

        this.currentAirportInfo = this.getScheduledAirportInfo(this.currentCheckride?.ScheduledAirportId);
      });
  }

  private handleAirportChange() {
    if (!this.airportInfoList) {
      return;
    }

    if (this.newCheckride.ScheduledAirportId == this.currentCheckride?.ScheduledAirportId || !this.currentCheckride?.ScheduledAirportId) {
      return;
    }

    this.currentAirportInfo = this.getScheduledAirportInfo(this.currentCheckride?.ScheduledAirportId);

    if (!this.currentAirportInfo) {
      this.loadAirportInfo();
    }
  }

  setupNewApplicant(applicant: FlightSchoolApplicantEntity) {
    this.newApplicant = applicant;
    this.currentCheckride = null;
    this.sameApplicantSelected = applicant?.FlightSchoolApplicantId == this.originalCheckride?.FlightSchoolApplicantId;

    if (!applicant) {
      return;
    }

    if (this.sameApplicantSelected) {
      this.showCancelSwapOptions = false;
      this.overrideErrors = false;
      this.isValidForOverride = false;
      this.validateApplicantChange()
        .subscribe(result => {

        });
      return;
    }

    // Should only have one checkride active
    if (applicant?.CheckRideRequest?.length > 0) {
      this.currentCheckride = applicant.CheckRideRequest[0];

      this.loadAirportInfo();

      this.showCancelSwapOptions = true;
    }

    if (this.newApplicant.CheckRideGroupId != this.newCheckride.CheckRideGroupId || this.newApplicant.CheckRideTypeId != this.newCheckride.CheckRideTypeId) {

      const checkridePartial: Partial<CheckRideRequestEntity> = {};
      checkridePartial.CheckRideGroupId = this.newApplicant.CheckRideGroupId;
      checkridePartial.CheckRideTypeId = this.newApplicant.CheckRideTypeId;

      this.formApi.patchFormData(checkridePartial);
    }

    this.loadExaminerDetails();
  }

  handleCheckrideTypeChange() {

    // Just revalidate applicant changes to see if the checkride length changed
    this.validateApplicantChange()
      .subscribe(result => {

      });
  }

  loadExaminerDetails() {
    const examinerIds = [this.newCheckride.ScheduledPilotExaminerId];

    if (this.currentCheckride?.ScheduledPilotExaminerId) {
      examinerIds.push(this.currentCheckride.ScheduledPilotExaminerId);
    }

    this.schoolRepositoryService.getPilexosExaminerDetails(examinerIds)
      .subscribe(examinerDetails => {
        this.examinerDetails = examinerDetails;

        this.validateApplicantChange()
          .subscribe(result => {

          });
      });
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    const modalResult = new DwModalResult();

    modalResult.closeModal = true;
    modalResult.cancelled = false;
    modalResult.buttonCommand = buttonConfig.command;

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:
        return this.startChangeStudent(modalResult);

      default:
        // Otherwise we're cancelling
        modalResult.cancelled = true;

        return of(modalResult);
    }
  }

  private startChangeStudent(modalResult: DwModalResult): Observable<DwModalResult> {

    if ((this.lastIsValid === false && !this.overrideErrors) || this.validationStarted) {
      modalResult.closeModal = false;

      return of(modalResult);
    }
    // validate first
    return this.validateApplicantChange().pipe(
      mergeMap((isValid) => {
        const canOverrideValidation = !this.sameApplicantSelected
          && this.overrideErrors
          && this.dwSecurityUserService.hasPermission(AppPermissions.checkrideSwapCanOverride, false);

        if (!isValid && canOverrideValidation) {
          isValid = true;
        }

        if (!isValid) {

          modalResult.closeModal = false;
          return of(modalResult);
        }

        this.saving = true;
        this.savingMessage = 'Processing Applicant Change...';

        return this.schoolChangeApplicantUtilService.changeStudentApplicant(this.originalCheckride, this.newCheckride, this.cancelSwapValue, this.currentCheckride, this.newApplicant)
          .pipe(map((savedResult) => {
            this.saving = false;

            modalResult.data = savedResult;
            return modalResult;
          }), catchError(error => {
            modalResult.closeModal = false;
            modalResult.cancelled = true;

            this.saving = false;

            this.message = {
              severity: DwMessageSeverity.error,
              messageBody: `An error occurred while processing the applicant change: ${error.message || error}`
            }

            return of(modalResult);
          }));

      }));
  }

  message: DwMessage;

  validateApplicantChange(): Observable<boolean> {

    if (this.validationStarted) {

      this.revalidateAfter = true;
      return of(false);
    }

    let preventOverride = false;

    this.validationStarted = true;
    this.message = null;

    const validationResult: ChangeValidationResult = { warnings: [], errors: [] };

    if (!this.newApplicantId) {
      validationResult.errors.push('You must select a new applicant to proceed.');

      preventOverride = true;
    }

    if (this.sameApplicantSelected) {
      validationResult.errors.push('You must select a different applicant. The current applicant is already assigned to this checkride.');

      preventOverride = true;
      this.overrideErrors = false;
    }

    this.showCancelSwapOptions = false;

    if (!this.sameApplicantSelected && this.newApplicant && this.currentCheckride) {
      this.showCancelSwapOptions = true;
      this.allowSwap = true;

      if (this.currentCheckride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Rejected || this.currentCheckride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Draft) {
        this.cancelSwapValue = SchoolChangeApplicantSwapType.cancel;
        this.allowSwap = false;

        this.cancelSwapText = `Existing checkride for ${this.newApplicant.ApplicantName} must be cancelled.`;
      } else {
        this.cancelSwapText = `Existing checkride for ${this.newApplicant.ApplicantName}. Choose an option below.`;
      }

      if (this.currentCheckride.ScheduledAirportId != this.originalCheckride.ScheduledAirportId) {
        validationResult.errors.push('Airports changes are not allowed.');
      }
    }

    if (this.dateTimeUtilService.isBeforeToday(this.newCheckride.ScheduledDateTime)) {
      validationResult.warnings.push('The Checkride date and time is in the past.');

      preventOverride = true;
    }

    const validationObs: Observable<any>[] = [];

    // if (this.originalCheckride.CheckRideTypeId != this.newCheckride.CheckRideTypeId || this.originalCheckride.CheckRideTestTypeId != this.newCheckride.CheckRideTestTypeId) {
    //   validationResult.warnings.push('The Checkride Type has been changed from the original checkride. This could result in a different length of checkride or different requirements.');
    // }

    validationObs.push(this.validateExaminer(validationResult, this.newCheckride, this.originalCheckride, this.originalCheckride, 'new'));

    if (this.currentCheckride && this.cancelSwapValue == SchoolChangeApplicantSwapType.swap) {
      validationObs.push(this.validateExaminer(validationResult, this.currentCheckride, this.currentCheckride, this.originalCheckride, 'Previous Applicant\'s Checkride'));
    }


    return combineLatest(validationObs).pipe(mergeMap(() => {
      this.setupValidationMessages(validationResult);

      this.validationStarted = false;

      this.lastIsValid = validationResult.errors.length == 0;
      this.isValidForOverride = !this.lastIsValid && !preventOverride;

      if (this.revalidateAfter) {
        this.revalidateAfter = false;
        return this.validateApplicantChange();
      }

      return of(this.lastIsValid);
    }));
  }

  private setupValidationMessages(validationResult: ChangeValidationResult) {
    if (validationResult.errors.length > 0 || validationResult.warnings.length > 0) {
      const messages = validationResult.errors.map(e => this.mapErrorWarning(e, true)).concat(validationResult.warnings.map(w => this.mapErrorWarning(w, false)));

      this.message = {
        severity: validationResult.errors.length > 0 ? DwMessageSeverity.error : DwMessageSeverity.warning,
        messageBody: `<ul>${messages.join('')}</ul>`
      };
    } else {
      this.message = {
        severity: DwMessageSeverity.success,
        messageBody: 'The applicant change is valid and can be processed.'
      }
    }
  }




  validateExaminer(validationResult: ChangeValidationResult, checkride: CheckRideRequestEntity, durationReferenceCheckride: CheckRideRequestEntity, availabilityReferenceCheckride: CheckRideRequestEntity, context: string): Observable<{ isExaminerValid: boolean, durationChanged?: boolean, durationMinutes?: number }> {
    const examiner = this.examinerDetails?.find(e => e.PilotExaminerId == checkride.ScheduledPilotExaminerId);
    const sameSchedulingConfig = checkride?.ScheduledPilotExaminerId == durationReferenceCheckride?.ScheduledPilotExaminerId
      && checkride?.CheckRideTypeId == durationReferenceCheckride?.CheckRideTypeId
      && checkride?.CheckRideTestTypeId == durationReferenceCheckride?.CheckRideTestTypeId;

    const result: { isExaminerValid: boolean, durationChanged?: boolean, durationMinutes?: number } = {
      isExaminerValid: false
    }

    // if (!examiner || examiner.PilotExaminerTypeId == PilotExaminerTypeAllItems.BasicExaminer) {
    //   // This uses a school examiner so not additional checks needed

    //   return this.validateSchoolExaminer(validationResult, checkride, context);
    // }

    // Validate the examiner is still verified live on PilExOS (They can deactivate their account)
    if (examiner && examiner.PilotExaminerStatusId != PilotExaminerStatusAllItems.VerifiedLive) {
      validationResult.errors.push(`Examiner (${examiner.UserIdDisplay}) for the ${context} checkride is no longer active on PilExOS.`);
      return of(result);
    }

    if (sameSchedulingConfig) {
      result.isExaminerValid = true;
      return of(result);
    }

    let durationOb: Observable<number> = null;
    const checkrideTypeId = checkride.CheckRideTypeId;
    const checkrideTestTypeId = checkride.CheckRideTestTypeId;
    const currentScheduledTimeMinutes = durationReferenceCheckride?.ScheduledTimeMinutes ?? checkride?.ScheduledTimeMinutes;

    if (examiner?.PilotExaminerTypeId == PilotExaminerTypeAllItems.PilExOSExaminer) {
      const scenario = examiner?.CheckRideScenario?.find(s => s.CheckRideScenarioTypeMap?.some(m => m.CheckRideTypeId == checkrideTypeId) && s.IsActive);

      if (scenario == null) {
        validationResult.errors.push(`DPE ${examiner.UserIdDisplay} does not perform ${checkride.CheckRideGroupIdDisplay} - ${checkride.CheckRideTypeIdDisplay} checkrides`);

        result.isExaminerValid = false;
        return of(result);
      }

      const newDuration = this.examinerRepositoryService.getCheckrideTimeMinutesFromScenario(checkrideTestTypeId, scenario);

      durationOb = of(newDuration);
    } else {
      // This means if for a Non-Pilexos or Basic Examiner - we use the Checkride types to determine the time required
      durationOb = this.examinerRepositoryService.getCheckrideTimeMinutesFromType(checkrideTestTypeId, checkrideTypeId);
    }


    return durationOb.pipe(mergeMap((totalTimeRequiredMinutes) => {
      if (totalTimeRequiredMinutes != currentScheduledTimeMinutes) {
        result.durationChanged = true;
        result.durationMinutes = totalTimeRequiredMinutes;

        const originalDurationFormatted = this.dateTimeUtilService.formatDuration2(currentScheduledTimeMinutes * 60);
        const newDurationFormatted = this.dateTimeUtilService.formatDuration2(totalTimeRequiredMinutes * 60);
        
        validationResult.warnings.push(`Checkride duration has changed from  ${originalDurationFormatted} to ${newDurationFormatted}`);

        checkride.ScheduledTimeMinutes = totalTimeRequiredMinutes;
        this.newCheckride.ScheduledTimeMinutes = totalTimeRequiredMinutes;
      }

      const requiredScheduleCheck = result.durationChanged || checkride.CheckRideTypeId != durationReferenceCheckride?.CheckRideTypeId || checkride.CheckRideTestTypeId != durationReferenceCheckride?.CheckRideTestTypeId;
      
      // If no duration change, then we don't need to check availability as the time slot would be the same
      if (!requiredScheduleCheck) {
        console.debug('No schedule change detected, skipping availability check for examiner');
        return of(result);
      }

      if (checkride.CheckRideTypeId != durationReferenceCheckride?.CheckRideTypeId) {
        validationResult.warnings.push(`Category/Class has been changed`);
      } 
      if (checkride.CheckRideTestTypeId != durationReferenceCheckride?.CheckRideTestTypeId) {
        validationResult.warnings.push(`Type of Practical Test has been changed`);
      } 

      // Need to verify availability
      return this.schoolChangeApplicantUtilService.checkNewCheckrideAvailability(availabilityReferenceCheckride, checkride)
        .pipe(map((availableResult) => {

          if (!availableResult.Success) {
            validationResult.errors.push(`Error checking availability for Examiner ${examiner.UserIdDisplay}.  Error: ${availableResult.ErrorMessage}`);
          }
          if (availableResult.HasConflicts) {
            const checkrideDateTime = this.formatDateTimeForAirport(checkride.ScheduledDateTime, checkride.ScheduledAirportId);
            const checkrideDuration = this.dateTimeUtilService.formatDuration2(checkride.ScheduledTimeMinutes * 60);
            validationResult.errors.push(`Examiner ${examiner.UserIdDisplay} is no longer available at ${checkrideDateTime} for ${checkrideDuration}.`);
          }

          result.isExaminerValid = availableResult.Success && !availableResult.HasConflicts;
          
          return result;
        }));

    }));
  }
  
  formatDateTimeForAirport(dateTime: string, airportId: number) {
    const airportInfo = this.airportInfoList.find(a => a.AirportId == airportId);

    if (airportInfo?.TimeZoneIANAIdentifier) {
      const translatedDateTime = `${this.dateTimeUtilService.formatDateTimeToTimezone(dateTime, airportInfo?.TimeZoneIANAIdentifier || 'UTC')} ${airportInfo?.TimeZoneTimezoneShortName || ''}`;

      return translatedDateTime;
    }

    return this.dateTimeUtilService.formatDateTimeToLocal(dateTime);
  }


  getScheduledAirportInfo(ScheduledAirportId: number) {
    const airportInfo = this.airportInfoList?.find(a => a.AirportId == ScheduledAirportId);

    if (!airportInfo) {
      return null;
    }

    return airportInfo;

  }

  // getCheckrideDurationInfo(checkride: CheckRideRequestEntity, examiner: PilotExaminerEntity) {
  //   if (examiner.PilotExaminerTypeId == PilotExaminerTypeAllItems.PilExOSExaminer) {
  //     const scenario = examiner.CheckRideScenario?.find(s => s.CheckRideScenarioTypeMap?.some(m => m.CheckRideTypeId == this.newCheckride.CheckRideTypeId) && s.IsActive);

  //     if (scenario == null) {
  //       validationResult.errors.push(`DPE ${examiner.UserIdDisplay} does not perform ${checkride.CheckRideGroupIdDisplay} - ${checkride.CheckRideTypeIdDisplay} checkrides`);

  //       result.isExaminerValid = false;
  //       return of(result);
  //     }

  //     const totalTimeRequiredMinutes = scenario.TimeRequiredMinutes || 0;
  //     const originalTimeRequiredMinutes = this.originalCheckride.ScheduledTimeMinutes || 0;

  //     result.durationChanged = totalTimeRequiredMinutes != originalTimeRequiredMinutes;

  //     // Update the time needed for the new checkride
  //     this.newCheckride.ScheduledTimeMinutes = totalTimeRequiredMinutes;
  //     checkride.ScheduledTimeMinutes = totalTimeRequiredMinutes;
  //   } else {
  //   }
  // }

  private mapErrorWarning(message: string, isError: boolean): string {
    return `<li class="${isError ? 'error' : 'warning'}">${isError ? 'Error:' : 'Warning:'} ${message}</li>`;
  }

  ngOnDestroy?: () => void;


}


interface ChangeValidationResult {
  warnings: string[];
  errors: string[];

}
